import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *活动列表
 * @param params
 * 
*/

export const activityList = params => Http.get(`${baseUrl}/activity`, { params })

/**
 *新增活动
 * @param params
 * 
*/

export const addActivity = params => Http.post(`${baseUrl}/activity`,  params )

/**
 *修改活动
 * @param params
 * 
*/

export const editActivity = params => Http.put(`${baseUrl}/activity`, params )

/**
 *查看活动详情
 * @param activityId
 * 
*/

export const activityInfo = activityId => Http.get(`${baseUrl}/activity/${activityId}`)

/**
 *删除活动
 * @param activityId
 * 
*/

export const delActivity = activityId => Http.delete(`${baseUrl}/activity/${activityId}`)
